export default __webpack_public_path__ + "9736ce24ac0415c11bf99c1f0cef154b.png";